import SquareImageWithLabel from "./SquareImageWithLabel";
export * from "./SquareImageWithLabel";

export default SquareImageWithLabel;
